/** The question bar, its answers and the custom builder all live on /reports
 *  (owner, 2026-10-03: "keep everything in one page"). `/reports/custom`
 *  redirects here. */
export const CUSTOM_REPORT_PATH = '/reports';
